import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles, Typography } from '@material-ui/core';

const styles = theme => ({
    root: {
    },
    therapist: {
        marginBottom: theme.spacing(1),
    },
});

class StudentTeacherList extends React.Component {
    render() {
        const {
            classes, translate, studentData,
        } = this.props;

        if (!studentData) {
            return null;
        }

        return (
            <div className={classes.root}>
                {studentData.therapists ? studentData.therapists.map(therapist => (
                    <div className={classes.therapist} key={therapist.therapistId}>
                        <Typography variant="subtitle1">
                            {therapist.therapistName}
                        </Typography>
                    </div>
                )) : (
                    <Typography>
                        {translate('student.noTeachersAssigned')}
                    </Typography>
                )}
            </div>
        );
    }
}

StudentTeacherList.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    studentData: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(StudentTeacherList));
